import {WebhookWizard} from "./webhook_wizard"

class LocationWebhooks extends HTMLElement {
  constructor() {
    super();
    this.domain_id = document.querySelector("#object_id").value
  }

  connectedCallback() {
    this.innerHTML = `
      <style>
        #webhooks_table_wrapper a.delete {
          cursor: pointer;
        }
        .integrations-buttons-row {
          margin-top: 10px
        }
      </style>
      
      <div class="row" id="list_webhook_management" style="margin: 0px 20px">
        <div class="row">
          <div class="col-sm-12 no-gutters">
            <h3>Integration Managemnt</h3>
            <span>Use Webhook or Email Integration to provide your application with real-time information</span>
          </div>
        </div>

        <div class="row integrations-buttons">
          <div class="col-sm-12 pull-right integrations-buttons-row">
            <button type="button" class="btn btn-primary pull-right" style="position: absolute;right: 0px;top: -6px;" data-toggle="modal" id="add_webhook_template">
            Add Integration
            </button>
            <div id="campaign_list_alerts">
            </div>
          </div>
        </div>
        <br>
        <br>
        <table id="webhooks_table" class="table" style="width:100%; display:table;">
          <thead>
              <tr>
                <th></th>
                <th>Name</th>
                <th>Integration Type</th>
                <th>Template</th>
                <th>In Use</th>
                <th>Action</th>
              </tr>
          </thead>
        </table>

      </div>`
    

    this.initTable()
    this.data_binder = new DataBinder("/admin/domains/"+this.domain_id+"/actions", true);
    this.data_binder.register(this);
    if(this.data_binder.data) this.requestUpdate(this.data_binder.data);
    
    this.querySelector("#add_webhook_template").addEventListener('click',this.createWebhook.bind(this))
  }

  requestUpdate(data){
    this.data = data;

    this.table.clear();
    this.table.rows.add(this.data);
    this.table.draw();
  }

  initTable() {
    this.table = $('table#webhooks_table').DataTable({
      dom: 'lftip',
      "lengthMenu": [[10, 25, 50, 100, -1],[10, 25, 50, 100, "All"]],
      buttons: [
          {
              text: 'My button',
              action: function ( e, dt, node, config ) {
                  alert( 'Button activated' );
              }
          }
      ],
      select: false, 
      search: false,
      "autoWidth": false,
      columns: [
        {
          className      : 'details-control',
          defaultContent : '',
          data           : null,
          orderable      : false,
        },
        { data : "name", "visible" : true, "searchable":true, "orderable":true,
          render: function ( data, type, row ) {
                    return data;
                }},
        { data: "action_type", render: function ( data, type, row ) {
            return ( type === 'display') ? (data == "WEBHOOK" ? "Webhook" : "Email") : data
          }},
        { "visible" : true, "searchable":true, "orderable":true,
          render: function ( data, type, row ) {
                    return row.action_template.name;
                }},
        {
          "visible" : true, "searchable":false, "orderable":true,
          render: function ( data, type, row ) {
                    return ( type === 'display') ? `<i class="fa ${row.is_used ? "fa-check" : "fa-times" }" aria-hidden="true"></i>` : row.is_used;
                }},
        { "visible" : true, "searchable":false, "orderable":false, "className": "delete-cell",
          render: function ( data, type, row ) {
                    return !row.is_used ? `<a class='delete' data-id='${row.action_id}' data-name='${row.name}'>Delete</a>` : "";
                }},
        
        ],
        "order": [[ 1, "asc" ]]
    });

    $(this.table.table().container() ).removeClass( 'form-inline' );

    $('table#webhooks_table').on("click", ".delete", async function(e) {
      if(confirm(`Are you sure you want to delete the Webhook ${$(e.target).data('name')}`)) {
        let res = await fetch('/admin/actions/'+$(e.target).data('id'), {
          headers: {'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')},
          method: 'DELETE'
        });
        let data = await res.json();
        if(data.success) {
          this.data_binder.fetchData();
        }
      }
    }.bind(this));

    $('table#webhooks_table tbody').on('click', 'td.details-control', (e) => {

         let tr  = $(e.target).closest('tr'),
             row = this.table.row(tr);
          
         if (row.child.isShown()) {
           tr.next('tr').removeClass('details-row');
           row.child.hide();
           tr.removeClass('shown');
         }
         else {
           let oldSelectedTr = $("table#webhooks_table tr.shown");
           if(oldSelectedTr.size() > 0) {
            let oldSelectedRow = this.table.row(oldSelectedTr);
            oldSelectedTr.next('tr').removeClass('details-row');
            oldSelectedRow.child.hide();
            oldSelectedTr.removeClass('shown');
           }
          tr.addClass('shown');
          this.loadWebhookDetail();
        }
      });
  }

  loadWebhookDetail() {
    let tr  = $("table#webhooks_table tbody tr.shown"),
    row = this.table.row(tr);

    let data = row.data();
    row.child("<div id='details_"+data.action_id+"'>Loading...</div>").show();
    $.get('/admin/actions/'+data.action_id, function(res) {
      if(res.action_type == "WEBHOOK") {
        let detail_row = document.createElement("webhook-detail");
        detail_row.data = res;
        //console.log(res)
        $("#details_"+data.action_id).html(detail_row);
        $(".checkbox").bootstrapSwitch();
        Common.mask_inputs();
      } else {
        let detail_row = document.createElement("email-detail");
        detail_row.data = res;
        //console.log(res)
        $("#details_"+data.action_id).html(detail_row);
      }
    });
    tr.next('tr').addClass('details-row');
  }

  createWebhook() {
    this.querySelector("#list_webhook_management").classList.add("hidden")
    let webhook_wizard = new WebhookWizard(() => this.querySelector("#list_webhook_management").classList.remove("hidden"))
    this.appendChild(webhook_wizard)
  }
}

customElements.define('location-webhooks', LocationWebhooks)


class WebhookDetail extends HTMLElement {
    
    constructor() {
      super();
    }
    
    connectedCallback() {
      this.domain_id = document.querySelector("#object_id").value
      this.data.action_parameters.map(function(action_param) {
        this.data[action_param.parameter_name] = action_param.parameter_value
      }.bind(this));
      if(this.data.headers != null){
        this.data.headers = JSON.parse(this.data.headers);
      }
      this.innerHTML = `
        <style>
          #list_webhook_management .webhook_http_headers > div .add_webhook_http_headers {
            display: none;
          }

          #list_webhook_management .webhook_http_headers > div:last-child .add_webhook_http_headers {
            display: inline-block;
          }

          #list_webhook_management .webhook_http_headers > div:only-child .remove_webhook_http_headers {
            display: none;
          }

          webhook-detail > div > .row {
              margin-top: 10px;
          }
        </style>

        <div class="col-sm-12">
          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label>Webhook Name</label>
                <input type="text" class="form-control webhook_name" data-required="true" placeholder="Webhook Name" value="${this.data.name}">
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label>URL</label>
                <input type="text" class="form-control webhook_url" data-required="true" data-validate="url" placeholder="example: http://mydomain.com/?param=mystaticparam" value="${this.data.url}">
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label>Template</label>
                <select class="form-control template" data-required="true" is="webhook-template-select" data-selected="${this.data.action_template_id}" data-domain_id=${this.domain_id}>
                </select>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label>Success Response Code</label>
                <select class="form-control success_response_code" data-required=true>
                  <option>200</option>
                  <option>201</option>
                  <option>202</option>
                  <option>203</option>
                  <option>204</option>
                </select> 
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-6">
              <div class="form-group">
                <div class="row">
                  <div class="col-md-5">
                      <label for="exampleInputPassword1">HTTP Header</label>
                  </div>
                  <div class="col-md-4">
                      <label for="exampleInputPassword1">Value</label>
                  </div>
                </div>
                <div class="webhook_http_headers">
                  
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label>HTTP Method</label>
                <select class="form-control http_method" data-required=true>
                  <option value="POST">POST</option>
                  <option value="PUT">PUT</option>
                </select> 
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12">
              <button type="button" class="btn pull-right btn-primary save">Save</button>
              <!--button type="button" class="btn pull-right btn-success test" style="margin-left:10px;">Test</button-->
              <button type="button" class="btn pull-right btn-outline-secondary cancel">Cancel</button>
            </div>
          </div>
        </div>
      `;

      this.querySelector(".success_response_code").value = this.data.success_code
      this.querySelector(".http_method").value = this.data.method

      this.querySelector(".save").addEventListener("click", function(){
        if(this.validate()) this.save();
      }.bind(this));

      /*this.querySelector(".test").addEventListener("click", function(){
        this.sendTestWebhook();
      }.bind(this));*/

      this.querySelector(".cancel").addEventListener("click", function(){
        $(this).closest('tr').prev('tr').find('td.details-control').click();
      });

      this.querySelector(".template").addEventListener("change", function() {
        let template_type = this.querySelector(".template option:checked").dataset.template_type;
        this.querySelector(".webhook_http_headers .row input.header_name").value = "Content-Type";
        let content_type = template_type == "JSON" ? "application/json" : "application/xml";
        this.querySelector(".webhook_http_headers .row input.header_value").value = content_type;        
      }.bind(this));

      if(this.data.headers != null) {
        Object.keys(this.data.headers).forEach(function(key) {
          this.addWebhookHeader(key, this.data.headers[key]);
        }.bind(this)); 
      }
      else {
        this.addWebhookHeader();
      }
    }

    addWebhookHeader(key = null, value = null) {
      let header = document.createElement("div");
      header.classList.add("row");
      header.innerHTML = this.webhookHeader(key, value);
      this.querySelector(".webhook_http_headers").appendChild(header);
      header.querySelector(".fa-minus").addEventListener('click', function() {
        this.closest(".webhook_http_headers").removeChild(this.closest(".row"));
      });
      header.querySelector(".fa-plus").addEventListener('click', function() {
        this.addWebhookHeader();
      }.bind(this));
    }

    validate() {
      let error_found = false;
      let required_error_found = false;
      this.querySelectorAll("input[type=text], select").forEach((input) => {
        input.classList.remove("error");

        if(input.dataset.required == "true" && input.value == "") {
          input.classList.add("error");
          required_error_found = true;
          error_found = true
        } else if(input.dataset.validate == "url") {
          var pattern = new RegExp('^(https?:\\/\\/)'+ // protocol
            '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|'+ // domain name
            '((\\d{1,3}\\.){3}\\d{1,3}))'+ // OR ip (v4) address
            '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*'+ // port and path
            '(\\?[;&a-z\\d%_.~+=-]*)?'+ // query string
            '(\\#[-a-z\\d_]*)?$','i'); // fragment locator
          if(!pattern.test(input.value)) {
            input.classList.add("error");
            error_found = true;
            Common.notify("Please enter a valid URL.", "error");
          }
        }
      });

      if(required_error_found) {
        Common.notify("Please enter all required values.", "error");
      }

      return !error_found
    }

    async save() {
      let postPackage = {};
      
      let webhookHeaders = {};
      this.querySelectorAll(".webhook_http_headers .row").forEach(function(row) {
        if(row.querySelector(".header_name").value != "") {
          webhookHeaders[row.querySelector(".header_name").value] = row.querySelector(".header_value").value; 
        }
      });

      let webhookData = {
        name: this.querySelector(".webhook_name").value,
        action_template_id: this.querySelector(".template").value,
        params: [
          {name: "success_code", value: this.querySelector(".success_response_code").value},
          {name: "headers", value: JSON.stringify(webhookHeaders)},
          {name: "url", value: this.querySelector(".webhook_url").value},
          {name: "method", value: this.querySelector(".http_method").value},
        ]
      }
      postPackage = webhookData;
      console.log(JSON.stringify(postPackage));
      let res = await fetch('/admin/actions/'+this.data.action_id, {
        headers: {'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content'),
                  'Content-type': 'application/json'},
        method: 'PUT',
        body: JSON.stringify(postPackage)
      })
      let data = await res.json();
      if(data.success) {
        this.data_binder = new DataBinder("/admin/domains/"+this.domain_id+"/actions", true);
        this.data_binder.fetchData();
      }
    }

    webhookHeader(key = null, value = null) {
      return `
            <div class="col-md-5 no-gutters">
                <input type="text" class="form-control header_name" placeholder="HTTP Header Name" value="${key != null ? key : ''}" />
            </div>
            <div class="col-md-4">
                <input type="text" class="form-control header_value" placeholder="Value" value="${value != null ? value : ''}" />
            </div>
            <div class="col-md-3" style="line-height:30px;">
              <a class="remove_webhook_http_headers"><span class="fa fa-minus"></span></a>
              <a class="add_webhook_http_headers"><span class="fa fa-plus"></span></a>
            </div>
         `
    }
    
  }
  customElements.define('webhook-detail', WebhookDetail);

  class EmailDetail extends HTMLElement {
    
    constructor() {
      super();
    }
    
    connectedCallback() {
      this.domain_id = document.querySelector("#object_id").value
      this.data.action_parameters.map(function(action_param) {
        this.data[action_param.parameter_name] = action_param.parameter_value
      }.bind(this));
      if(this.data.headers != null){
        this.data.headers = JSON.parse(this.data.headers);
      }
      this.innerHTML = `
        <style>
          email-detail > div > .row {
              margin-top: 10px;
          }
        </style>

        <div class="col-sm-12">
          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label>Email Name</label>
                <input type="text" class="form-control email_name" data-required="true" placeholder="Webhook Name" value="${this.data.name}">
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label>Email Subject</label>
                <input type="text" class="form-control email_subject" placeholder="Subject" value="${this.data.email_subject}">
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label>Template</label>
                <select class="form-control existing_webhook_template" data-required="true" is="webhook-template-select" data-selected="${this.data.action_template_id}" data-domain_id=${this.domain_id}>
                </select>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label>Email Recipients</label>
                <textarea class="form-control email_integration_recipients" placeholder="Please separate email addresses by using a comma">${this.data.email_recipients}</textarea>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12">
              <button type="button" class="btn pull-right btn-primary save">Save</button>
              <!--button type="button" class="btn pull-right btn-success test" style="margin-left:10px;">Test</button-->
              <button type="button" class="btn pull-right btn-danger cancel">Cancel</button>
            </div>
          </div>
        </div>
      `;

      this.querySelector(".save").addEventListener("click", function(){
        if(this.validate()) this.save();
      }.bind(this));

      this.querySelector(".cancel").addEventListener("click", function(){
        $(this).closest('tr').prev('tr').find('td.details-control').click();
      });

    }

    validate() {
      let is_valid = true;
      if(this.querySelector(".email_name").value.trim().length == 0) {
        Common.notify("Please enter a Email Name.", "error");
        is_valid = false;
      }

      if(this.querySelector(".existing_webhook_template").value == "") {
        Common.notify("Please select a template.", "error");
        is_valid = false;
      }

      if(this.querySelector(".email_subject").value.trim().length == 0) {
        Common.notify("Please select a Email Subject.", "error");
        is_valid = false;
      }

      if(this.querySelector(".email_integration_recipients").value.trim().length == 0) {
        Common.notify("Please enter Email Recipients.", "error");
        is_valid = false;
      }
      else if(!Common.validateCommaSeperatedEmail(this.querySelector(".email_integration_recipients").value)) {
        Common.notify("Email Recipients are invalid.", "error");
        is_valid = false;
      }

      return is_valid;
    }

    async save() {
      let webhookData = {
        name: this.querySelector(".email_name").value,
        action_template_id: this.querySelector(".existing_webhook_template").value,
        params: [
            {name: "email_subject", value: this.querySelector(".email_subject").value},
            {name: "email_recipients", value: this.querySelector(".email_integration_recipients").value},
            {name: "email_template_alias", value: "GENERIC_EMAIL"}
          ]
      };

      let res = await fetch('/admin/actions/'+this.data.action_id, {
        headers: {'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content'),
                  'Content-type': 'application/json'},
        method: 'PUT',
        body: JSON.stringify(webhookData)
      })
      let data = await res.json();
      if(data.success) {
        this.data_binder = new DataBinder("/admin/domains/"+this.domain_id+"/actions", true);
        this.data_binder.fetchData();
      }
    }
  }
  customElements.define('email-detail', EmailDetail);
